import { Typography } from "antd";
import { FaGripVertical } from "react-icons/fa";
import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";
import { useSelector } from "react-redux";

import { IOrdenacaoFonteItem, IUpdateFonteFavorita } from "../../interfaces";
import { stateGlobal } from "../../../../../../../../interfaces/Global";

import { EmitirErro } from "../../../../../../../../services/EmitirErro";
import FonteActions, { IFonteActionsProps } from "../FonteActions";

interface IProps {
    item: IOrdenacaoFonteItem;
    solicitacaoId: number;
    onChangeFavorita: (item: IOrdenacaoFonteItem) => void;
    index: number;
    fonteActionsProps: Omit<IFonteActionsProps, "item" | "onToggleFavorite" | "favorita" | "solicitacaoId">;
    onUpdateFonteFavorita: (data: IUpdateFonteFavorita) => Promise<void>;
}

export default function FavoritasFonteItem({
    item,
    solicitacaoId,
    onChangeFavorita,
    index,
    fonteActionsProps,
    onUpdateFonteFavorita,
}: IProps) {

    const propsState = useSelector((state: stateGlobal) => state.global);
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({
        id: item.numero,
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.6 : 1,
    };

    const handleToggleFavorite = async () => {
        try {

            await onUpdateFonteFavorita({
                favorita: false,
                numeroFonte: item.numero,
                solicitacaoId,
            });

            onChangeFavorita({
                ...item,
                favorita: false,
            });
        } catch (error) {
            EmitirErro(error);
        }
    };

    return (
        <div
            ref={setNodeRef}
            style={{
                ...style,
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                justifyContent: 'space-between',
                padding: '6px 16px',
                border: `1px solid ${propsState.theme === 'light' ? '#d9d9d9' : '#434343'}`,
                borderRadius: 8,
                background: propsState.theme === 'light' ? '#ffffff' : '##141414',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                }}
            >
                <div
                    {...attributes}
                    {...listeners}
                    style={{
                        cursor: 'grab',
                        display: 'flex',
                        alignItems: 'center',
                        touchAction: 'none',
                    }}
                >
                    <FaGripVertical
                        size={14}
                        type="secondary"
                        color={propsState.theme === 'light' ? "#00000073" : '#ffffff73'}
                    />
                </div>

                <div
                    style={{
                        minWidth: 20,
                        width: 20,
                        height: 20,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: propsState.theme === 'light' ? '#e9eaec86' : '#75757590',
                        borderRadius: 4,
                    }}
                >
                    <Typography.Text type="secondary">{index + 1}</Typography.Text>
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Typography.Text>{item.descricao}</Typography.Text>
                    <Typography.Text type="secondary">{item.numero}</Typography.Text>
                </div>
            </div>

            <FonteActions
                {...fonteActionsProps}
                favorita
                item={item}
                onToggleFavorite={handleToggleFavorite}
                solicitacaoId={solicitacaoId}
            />
        </div>
    );
}
